export const mockFleetMetrics = {
  totalVehicles: 312,
  healthyVehicles: 286,
  activeAlerts: 18,
  maintenanceDue: 27,
  avgFuelEfficiency: 27.4,
  totalMileage: 4_812_903,
  uptime: 99.4,
  trend: [
    { label: '24h', vehicles: 305, alerts: 22 },
    { label: '7d', vehicles: 298, alerts: 30 },
    { label: '30d', vehicles: 284, alerts: 41 },
  ],
};

export const mockVehicleActivity = [
  {
    id: 'FL-2847',
    status: 'healthy',
    detail: 'Completed predictive maintenance loop',
    delta: '+95% efficiency',
    timestamp: '2 min ago',
    icon: 'check',
    route: 'Dallas to Austin',
  },
  {
    id: 'TX-1923',
    status: 'warning',
    detail: 'Fuel reserve dipped below 15%',
    delta: 'Re-route to nearest depot',
    timestamp: '5 min ago',
    icon: 'alert',
    route: 'Houston loop',
  },
  {
    id: 'CA-5612',
    status: 'healthy',
    detail: 'Scheduled maintenance completed',
    delta: 'Turbine recalibrated',
    timestamp: '12 min ago',
    icon: 'wrench',
    route: 'San Jose diagnostics',
  },
  {
    id: 'NY-8734',
    status: 'critical',
    detail: 'Engine temp spike detected',
    delta: 'Auto throttle engaged',
    timestamp: '18 min ago',
    icon: 'zap',
    route: 'Albany corridor',
  },
];

export const mockAgentStatuses = [
  {
    id: 'diagnostics-core',
    name: 'Diagnostics Core',
    type: 'diagnosis',
    status: 'active',
    description: 'Runs adaptive fault trees for drivetrain',
    tasksProcessed: 1842,
    avgResponseTime: 142,
    uptime: '42h',
    version: '3.8.1',
    createdAt: '2024-08-01',
    lastUpdated: '2025-11-05',
  },
  {
    id: 'maintenance-orchestrator',
    name: 'Maintenance Orchestrator',
    type: 'scheduling',
    status: 'active',
    description: 'Schedules service windows with technician load-balancing',
    tasksProcessed: 1364,
    avgResponseTime: 188,
    uptime: '72h',
    version: '2.6.0',
    createdAt: '2024-09-17',
    lastUpdated: '2025-11-06',
  },
  {
    id: 'fleet-safety-net',
    name: 'Fleet Safety Net',
    type: 'feedback',
    status: 'processing',
    description: 'Applies CAPA playbooks for regional recalls',
    tasksProcessed: 912,
    avgResponseTime: 224,
    uptime: '18h',
    version: '2.1.4',
    createdAt: '2024-07-22',
    lastUpdated: '2025-11-06',
  },
];

export const mockAlertStream = [
  {
    id: 'alert-001',
    title: 'Thermal spike beyond tolerance',
    message: 'Powertrain coolant reached 112C for VIN 5YJ3E1EA1JF000000',
    severity: 'critical',
    timestamp: new Date().toISOString(),
    vehicleId: 'VIN-001',
    vehicle_id: 'VIN-001',
    type: 'system',
    acknowledged: false,
    resolved: false,
  },
  {
    id: 'alert-002',
    title: 'Battery degradation trend up',
    message: 'Detected 4.7% delta in 7 days on vehicle GA-9981',
    severity: 'warning',
    timestamp: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
    vehicleId: 'VIN-002',
    vehicle_id: 'VIN-002',
    type: 'performance',
    acknowledged: true,
    resolved: false,
  },
];

export const mockCustomerVehicles = [
  {
    id: 'veh-001',
    vin: '5YJ3E1EA1JF000000',
    make: 'Tesla',
    model: 'Model 3',
    year: 2023,
    status: 'healthy',
    mileage: 18420,
    lastUpdated: new Date().toISOString(),
    fuelLevel: 82,
    batteryLevel: 82,
  },
  {
    id: 'veh-002',
    vin: '1HGCM82633A004352',
    make: 'Honda',
    model: 'Accord Hybrid',
    year: 2022,
    status: 'warning',
    mileage: 23102,
    lastUpdated: new Date().toISOString(),
    fuelLevel: 34,
    batteryLevel: 64,
  },
  {
    id: 'veh-003',
    vin: '1C4RJEBG8MC000000',
    make: 'Jeep',
    model: 'Grand Cherokee 4xe',
    year: 2021,
    status: 'maintenance',
    mileage: 40213,
    lastUpdated: new Date().toISOString(),
    fuelLevel: 45,
    batteryLevel: 52,
  },
];

export const mockServiceAppointments = [
  {
    appointment_id: 'appt-101',
    vehicle_id: 'veh-001',
    service_type: 'Battery health recalibration',
    scheduled_date: new Date(Date.now() + 1000 * 60 * 60 * 24).toISOString(),
    status: 'scheduled',
    service_center: 'Austin Diagnostics Hub',
  },
  {
    appointment_id: 'appt-102',
    vehicle_id: 'veh-002',
    service_type: 'Thermal management update',
    scheduled_date: new Date(Date.now() + 1000 * 60 * 60 * 48).toISOString(),
    status: 'awaiting_approval',
    service_center: 'Houston Mobility Lab',
  },
];

export const mockManufacturingInsights = {
  plants: [
    {
      id: 'plant-a',
      name: 'Detroit Line A',
      throughput: 412,
      efficiency: 94,
      downtime: 12,
      defects: 6,
      energyUsage: 78,
    },
    {
      id: 'plant-b',
      name: 'Austin EV Lab',
      throughput: 368,
      efficiency: 91,
      downtime: 18,
      defects: 9,
      energyUsage: 81,
    },
  ],
  qualityInitiatives: [
    { name: 'Torque calibration 2.0', impact: '+4.3% quality', status: 'on_track' },
    { name: 'Vision QA with GenAI', impact: '-38% false positives', status: 'pilot' },
    { name: 'Automated CAPA routing', impact: '-26% time-to-close', status: 'scaling' },
  ],
  recurringDefects: [
    { component: 'Thermal gasket', occurrences: 14, severity: 'high' },
    { component: 'Battery busbar', occurrences: 9, severity: 'medium' },
    { component: 'Torque sensor', occurrences: 6, severity: 'medium' },
  ],
};
